// extracted by mini-css-extract-plugin
export default {"action-button":"aruPXi","actionButton":"aruPXi","rounded":"RGM78Q"};